

export function Person() {
    return(
        <div>
            <div style={{marginBottom: "10px"}}>
                <div>개인정보보호법에 따라 (주)오메가포인트가 다음과 같이 개인정보를 수집, 이용함에 동의합니다. 동의하지 않으실 경우, 서비스 이용이 제한됩니다.</div>
            </div>
            <div>
                <div>- 수집하는 개인정보: 학생 이름, 성별, 학교명, 학년, 학부모 전화번호, 거주지</div>
                <div>- 개인정보 이용 목적: 신청 항목의 접수 및 서비스 이행, 이용 관련 안내</div>
                <div>- 개인정보 보관기간: 서비스 종료시까지(신청일로부터 최대 5년)</div>
            </div>
        </div>
    )
}

export function Transfer() {
    return(
        <div>
            <div style={{marginBottom: "10px"}}>
                <div>개인정보보호법에 따라 (주)오메가포인트가 다음과 같이 개인정보를 제3자에게 이전함에 동의합니다. 동의하지 않으실 경우, 서비스 이용이 제한됩니다.</div>
            </div>
            <div>
                <table style={{borderCollapse: "collapse"}}>
                    <thead></thead>
                    <tbody>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>제공받는 자</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>신청 대상 지역 시매쓰 가맹점</td>
                        </tr>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>제공 목적</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>신청 항목의 접수 및 서비스 이행, 이용 관련 안내, 마케팅 정보 발신</td>
                        </tr>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>제공 항목</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>학생 이름, 성별, 학교명, 학년, 학부모 전화번호, 거주지</td>
                        </tr>
                        <tr>
                            <td style={{width: "30%", height: "40px", border: "0.5px solid #EFEFEF", textAlign: "center"}}>보관 기간</td>
                            <td style={{border: "0.5px solid #EFEFEF", padding: "10px", boxSizing: "border-box"}}>서비스 종료시까지(신청일로부터 최대 5년)</td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
            </div>
        </div>
    )
}

export function Promotion() {
    return(
        <div>
            <div>시매쓰에서 제공하는 이벤트/혜택 등 다양한 정보를 휴대전화로 받아보실 수 있습니다. 프로모션 정보 수신 동의는 이용자가 신청한 시매쓰 학원을 통해 언제든지 철회할 수 있습니다.</div>
        </div>
    )
}